import React from 'react';
import { Modal } from 'antd';
import { Container, Paragraph, LinkStyled } from './styles';

const ModalAlertPass = () => {
  return (
    <Modal zIndex={999} closable={false} visible={true} footer={false}>
      <Container>
        <Paragraph>
          Prezado aluno, por questões de segurança a ART pede que você altere sua senha para
          continuar estudando pelas nossas plataformas. Obrigado :)
        </Paragraph>
        <LinkStyled to={'/user/pass'}>Alterar minha senha &gt;</LinkStyled>
      </Container>
    </Modal>
  );
};

export default ModalAlertPass;
